import { render, staticRenderFns } from "./GSheetTable.vue?vue&type=template&id=14683f85&"
import script from "./GSheetTable.vue?vue&type=script&lang=js&"
export * from "./GSheetTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14683f85')) {
      api.createRecord('14683f85', component.options)
    } else {
      api.reload('14683f85', component.options)
    }
    module.hot.accept("./GSheetTable.vue?vue&type=template&id=14683f85&", function () {
      api.rerender('14683f85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/googleSheet/components/GSheetTable.vue"
export default component.exports